import React from 'react';
import Header from '../../components/Header';
import Menu from '../../components/Menu';
import './styles.scss';

const About: React.FC = () => {
  return (
    <>
      <Header />
      <div className="container about">
        <Menu />
        <div className="content">
          <h1>Sobre o Vein Risk</h1>
          <p>
            Vein Risk é uma ferramenta útil desenvolvida a partir de pesquisas
            científicas reunidas por médicos de cirurgia vascular
            <sup>.1,2.</sup> Permite uma melhor atenção e diálogo sobre as
            doenças venosas entre médicos, farmacêuticos e doentes.
          </p>

          <p>
            O Vein Risk pode avaliar a idade das veias, dos doentes, de acordo
            com a presença de sinais ou sintomas de doença venosa crónica. O
            Vein Risk também permite informar os doentes sobre a evolução da
            doença venosa de acordo com a presença de sinais ou sintomas e os
            fatores de risco (estilo de vida, gravidez, hereditariedade, idade,
            sexo, excesso de peso ou obesidade).
          </p>

          <p>
            O profissional de saúde insere a idade do doente, o gênero, a
            presença ou ausência de hereditariedade, a presença ou ausência de
            pelo menos duas gravidezes de termo, a altura, o peso, o estilo de
            vida (se permanece sentado ou de pé mais de 8 horas por dia) e
            indica os seguintes sinais ou sintomas: dor, sensação de pernas
            pesadas, varizes, edema venoso... Em apenas 1 minuto, o Vein Risk
            avalia a idade das veias e estima a evolução dos sinais clínicos
            para os próximos 10 a 20 anos, atribuindo-lhe uma pontuação. Se a
            idade das veias for superior à idade do doente, a aplicação
            disponibiliza conselhos para alteração de estilo de vida e
            informação geral sobre doença venosa crônica.
          </p>

          <p>
            O objetivo do Vein Risk não é substituir o médico, que é a única
            autoridade com capacidade para fazer um diagnóstico, para iniciar ou
            modificar um tratamento. Esta aplicação não se destina a ser
            utilizada para o diagnóstico, prevenção, monitorização, tratamento
            ou alívio da patologia. O seu objetivo é fornecer informação sobre a
            doença venosa crónica. Referências:
          </p>

          <p>
            1 - Estimation of the age veineux d'après Allaert F.A., Crébassa V.
            Comment sensibiliser les patients à leur pathologie veineuse? Un
            nouvel outil: le calcul de l’âge veineux. Phlébologie. 2014. 67; 2;
            1-5.
          </p>

          <p>
            2 - O "VeinRisk": score d'évolutivité des affections veineuses
            chroniques. Phlébologie. 2015. 68; 3; 26-33.
          </p>
        </div>
      </div>
    </>
  );
};

export default About;
